import React, { useContext } from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const userId = JSON.parse(localStorage.getItem("user"))?.user_id;

  if (!userId) {
    return <Navigate to="/unauthorized" />;
  }
  return children;
};
export default PrivateRoute;
